import React from "react";
import { ResizeHandleComponentType } from "react-shape-editor";

type ResizeHandleProps = React.ComponentProps<ResizeHandleComponentType>;

// creates a border around the frame allowing the frame to be resized
export const AnnotationFrameResizeContainer = ({
    active,
    cursor,
    onMouseDown,
    scale,
    x,
    y,
    name,
}: ResizeHandleProps) => {
    return (
        <circle
            cx={x}
            cy={y}
            r={4 / scale}
            fill={active ? "rgba(28, 240, 3, 0.9)" : "rgba(28, 240, 3, 0.3)"}
            stroke={active ? "rgba(53, 33, 140, 0.5)" : "rgba(53, 33, 140, 0.3)"}
            strokeWidth={1 / scale}
            style={{
                cursor,
                display: ["w", "n", "s", "e"].includes(name) ? "none" : "",
            }}
            onMouseDown={onMouseDown}
        />
    );
};
